import { Injectable } from '@angular/core';
import { ApiService } from 'src/app/core/services/api.service';
import { map } from 'rxjs/operators';
import { Entity } from 'src/app/models/entities.model';
import { Relation } from 'src/app/models/relations.model';
import { Document } from 'src/app/features/documents/models/document.models';
import { Permission } from 'src/app/models/Users';
import { ValidationRejection, EntityValidation, ValidationAprovalRequest } from '../models/entity-validation.model';
import { Observable } from 'rxjs';
import { PaginationHelpers } from 'src/app/core/classes/pagination.helpers';
import { Athlete } from 'src/app/models/athletes.model';
import { Club } from 'src/app/models/clubs.model';

export interface UserPermission {
  id: number;
  name: string;
  nickname: string;
  email: string;
  photo_url: string;
  validated: boolean;
  permissions: Permission;
}
export interface UnregisteredSearchOptions {
  league_id?: number;
  club_id?: number;
  athlete_id?: number;
}

export interface EntityValidationData {
  entity: Entity;
  relations: Relation[];
  documents: Document[];
  history: EntityValidation[];
  permissions: UserPermission[];
}

export class LeagueUnvalidatedAthlete extends Athlete {
  club: Club;
}

@Injectable({
  providedIn: 'root'
})
export class EntityValidatorService {

  constructor(
    private api: ApiService
  ) { }

  getLeagueAthletesToValidate(leagueID: number) {
    return this.api.get<LeagueUnvalidatedAthlete[]>(`entity_validations/league/${leagueID}/athletes_to_validate`)
      .pipe(map(res => res.payload));
  }

  getEntityData(entityId: number) {
    return this.api.get<EntityValidationData>(`entity_validations/entity/${entityId}`).pipe(map(res => res.payload));
  }

  getValidationByUID(validationUID: string) {
    return this.api.get<EntityValidation>(`entity_validations/by_uid/${validationUID}`).pipe(map(res => res.payload));

  }

  reject(entityID: number, rejections: ValidationRejection[]): Observable<{ entityUpdated: Entity, validation: EntityValidation }> {
    return this.api.post<{ entityUpdated: Entity, validation: EntityValidation }>
      (`entity_validations/entity/${entityID}/reject`, rejections).pipe(map(res => res.payload));
  }

  aprove(entityID: number, data: ValidationAprovalRequest): Observable<{ entityUpdated: Entity, validation: EntityValidation }> {
    return this.api.post<{ entityUpdated: Entity, validation: EntityValidation }>
      (`entity_validations/entity/${entityID}/aprove`, data).pipe(map(res => res.payload));
  }

}
